import { render, staticRenderFns } from "./cashback.pug?vue&type=template&id=0a6d3a51&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./cashback.scss?vue&type=style&index=0&id=0a6d3a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d3a51",
  null
  
)

export default component.exports